/**
 * Checks if the input is a valid [lng, lat] coordinate array.
 * @param coord - The value to check.
 * @returns True if valid, false otherwise.
 */
export function isValidLngLat(coord: unknown): coord is [number, number] {
    return (
        Array.isArray(coord) &&
        coord.length === 2 &&
        typeof coord[0] === "number" &&
        typeof coord[1] === "number" &&
        !isNaN(coord[0]) &&
        !isNaN(coord[1]) &&
        coord[0] >= -180 &&
        coord[0] <= 180 &&
        coord[1] >= -90 &&
        coord[1] <= 90
    );
}

export function createTriangleIcon() {
    const size = 20;
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    if (!ctx) return null;

    const centerX = size / 2;
    const centerY = size / 2;
    const triangleSize = size * 0.8;

    const points = [
        { x: centerX, y: centerY - triangleSize / 2 },
        { x: centerX - triangleSize / 2, y: centerY + triangleSize / 2 },
        { x: centerX + triangleSize / 2, y: centerY + triangleSize / 2 },
    ];

    ctx.fillStyle = "#ffffff";
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    ctx.lineTo(points[1].x, points[1].y);
    ctx.lineTo(points[2].x, points[2].y);
    ctx.closePath();
    ctx.fill();

    return ctx.getImageData(0, 0, size, size);
}
